import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const usePreserveQueryParamsNavigate = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  return useCallback(
    (to: string) => {
      navigate({ pathname: to, search });
    },
    [navigate, search]
  );
};
